import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=d91614a2&scoped=true&"
import script from "./CreateNews.vue?vue&type=script&lang=ts&"
export * from "./CreateNews.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=d91614a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91614a2",
  null
  
)

export default component.exports